var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { InputComponent } from '../Common';
import { CANCEL, ADD, NAME, NAME_KEY, PHONE, PHONE_KEY, TYPE_OF_SERVICE, TYPE_OF_SERVICE_KEY, ROUTES, PROVIDERS_API, ALL_FIELDS_ARE_REQUIRED, } from 'src/Utils/constants';
import { FormsContainer, FormContainer, ButtonsContainer, Link, ErrorMessage, BottomContainer, TextContainer, } from './styles';
import { AdminButton } from '../Common/AdminButton';
import { getData } from 'src/Utils';
import { isValidProviderForm } from 'src/Utils/validations';
import MultiSelect from '../Common/MultiSelect';
var ProviderForm = function (_a) {
    var onSubmit = _a.onSubmit, backError = _a.backError, setBackError = _a.setBackError, _b = _a.initialValues, initialValues = _b === void 0 ? {
        name: '',
        type_of_service: '',
        phone: '',
    } : _b;
    var history = useHistory();
    var _c = useState({}), formErrors = _c[0], setFormErrors = _c[1];
    var _d = useState([]), providerTypes = _d[0], setProviderTypes = _d[1];
    var _e = useState([]), selectedType = _e[0], setSelectedType = _e[1];
    var _f = useState({
        name: '',
        type_of_service: '',
        phone: '',
    }), formData = _f[0], setFormData = _f[1];
    useEffect(function () {
        setFormData(initialValues);
    }, []);
    useEffect(function () {
        setFormData(function (prevState) {
            var _a;
            var _b;
            return (__assign(__assign({}, prevState), (_a = {}, _a[TYPE_OF_SERVICE_KEY] = (_b = selectedType[0]) === null || _b === void 0 ? void 0 : _b.label, _a)));
        });
    }, [selectedType]);
    var isLoading = useQuery([PROVIDERS_API], function () { return getData("/providers"); }, {
        onSuccess: function (data) {
            var filteredList = (data.service_types || []).map(function (label) { return ({
                label: label,
                value: label,
            }); });
            setProviderTypes(filteredList);
        },
        retry: false,
    }).isLoading;
    var handleSubmit = function () {
        formErrors[NAME_KEY] = formData.name;
        formErrors[TYPE_OF_SERVICE_KEY] = formData.type_of_service;
        formErrors[PHONE_KEY] = formData.phone;
        if (isValidProviderForm(formErrors, setFormErrors)) {
            onSubmit(formData[NAME_KEY], formData[TYPE_OF_SERVICE_KEY], formData[PHONE_KEY]);
        }
        setBackError('');
    };
    var onCancel = function () { return history.push(ROUTES.providers); };
    return (React.createElement(FormsContainer, null,
        React.createElement(FormContainer, null,
            React.createElement(TextContainer, null, ALL_FIELDS_ARE_REQUIRED),
            React.createElement(InputComponent, { type: NAME_KEY, error: formErrors, label: NAME, onChangeFunction: function (e) {
                    e.persist();
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a[NAME_KEY] = e.target.value, _a)));
                    });
                }, data: formData[NAME_KEY] }),
            React.createElement(MultiSelect, { options: providerTypes, label: TYPE_OF_SERVICE, type: TYPE_OF_SERVICE_KEY, setSelectedOption: setSelectedType, errors: formErrors, initialValues: selectedType }),
            React.createElement(InputComponent, { type: PHONE_KEY, error: formErrors, label: PHONE, onChangeFunction: function (e) {
                    e.persist();
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a[PHONE_KEY] = e.target.value, _a)));
                    });
                }, data: formData[PHONE_KEY] }),
            React.createElement(BottomContainer, null,
                React.createElement(ButtonsContainer, null,
                    React.createElement(Link, { onClick: onCancel }, CANCEL),
                    React.createElement(AdminButton, { type: "button", onClick: handleSubmit, className: "height" }, ADD)),
                true && React.createElement(ErrorMessage, null, backError)))));
};
export default ProviderForm;
